<template>
  <div class="page">
    <div class="nav">
      <div>
        <router-link to="/deployments">
          {{ $t('allDeployments') }}
        </router-link>
        <v-icon>{{ rightIcon }}</v-icon>
        {{ deployment }}
      </div>
    </div>
    <v-tabs v-model="tab">
      <v-tab value="overview">{{ $t('overview') }}</v-tab>
      <v-tab value="topology">{{ $t('topology') }}</v-tab>
      <v-tab value="manage">{{ $t('manage') }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item key="overview" :transition="false" :reverse-transition="false">
        <u-overview :deployment="deployment" />
      </v-tab-item>
      <v-tab-item key="topology" :transition="false" :reverse-transition="false">
        <u-topology :deployment="deployment" />
      </v-tab-item>
      <v-tab-item key="manage" :transition="false" :reverse-transition="false">
        <u-manage :deployment="deployment" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mdiChevronRight } from '@mdi/js'
import Manage from './Manage.vue'
import Overview from './Overview.vue'
import Topology from './Topology.vue'

export default {
  data () {
    return {
      rightIcon: mdiChevronRight,
      tab: 'topology'
    }
  },
  computed: {
    deployment () {
      return this.$route.params.id
    }
  },
  created () {
    const deployment = this.deployment
    if (!deployment) {
      this.$router.push('/deployments')
    }
  },
  components: {
    'u-manage': Manage,
    'u-overview': Overview,
    'u-topology': Topology
  }
}
</script>

<style lang="scss" scoped>
.page {
  align-self: start;
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
  width: 100%;
}

.nav {
  flex: none;
}

.tabs {
  display: flex;
  flex: auto;
  flex-flow: column nowrap;
}

.v-tabs {
  flex: none;
}

.v-tabs-items {
  flex: auto;

  ::v-deep .v-window__container {
    display: contents;
  }

  .v-window-item--active {
    display: flex;
    flex-flow: column;
    height: 100%;
  }
}
</style>

<i18n>
{
  "en": {
    "allDeployments": "All Deployments",
    "manage": "Manage",
    "overview": "Overview",
    "topology": "Topology"
  }
}
</i18n>
